import { shopRepo } from '../repo';

export const shopService = {
    async getAll(params = {}) {
        try {
            const response = await shopRepo.getAll(params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getById(shopId) {
        if (!shopId) {
            throw new Error('Shop ID is required');
        }
        try {
            const response = await shopRepo.getById(shopId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async create(data) {
        if (!data.shop_name || data.shop_name.length < 3) {
            throw new Error('Shop name must be at least 3 characters');
        }
        if (!data.shop_type) {
            throw new Error('Shop type is required');
        }

        try {
            const response = await shopRepo.create(data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async registerShop(data) {
        if (!data.shop_name || data.shop_name.length < 3) {
            throw new Error('Shop name must be at least 3 characters');
        }
        if (!data.shop_type) {
            throw new Error('Shop type is required');
        }

        try {
            const response = await shopRepo.register(data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async update(shopId, data) {
        if (!shopId) {
            throw new Error('Shop ID is required');
        }

        try {
            const response = await shopRepo.update(shopId, data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async toggleStatus(shopId) {
        if (!shopId) {
            throw new Error('Shop ID is required');
        }

        try {
            const response = await shopRepo.toggleStatus(shopId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getTypes() {
        try {
            const response = await shopRepo.getTypes();
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getStats() {
        try {
            const response = await shopRepo.getAll({ per_page: 1000 });
            const shops = response.data?.data || [];
            return {
                total: shops.length,
                active: shops.filter(s => s.status === 'active').length,
                inactive: shops.filter(s => s.status === 'inactive').length,
            };
        } catch (error) {
            throw this.handleError(error);
        }
    },

    handleError(error) {
        console.error('ShopService Error:', error);
        return error.response?.data || error;
    },
};